import { useEffect } from 'react';
import { AxiosResponse } from 'axios';
import { useMutation } from '@tanstack/react-query';
import { useAderenciaPrecosStore } from '../AderenciaPrecos.store';

import * as service from '../services';
import { AderenciaBigNumbersBody } from '../types';

export const useAderenciaDetailing = () => {
  const { setAderenciaPrecosState, aderenciaDetailsBodyRequest } = useAderenciaPrecosStore();

  const getAderenciaDetailsRequest = async (data: AderenciaBigNumbersBody) => {
    const resp = await service.getAderenciaDetails(data);
    return resp;
  };

  const successAction = (data: AxiosResponse) => {
    setAderenciaPrecosState('aderenciaDetailsData', data?.data);
  };

  const mutate = useMutation({
    mutationFn: getAderenciaDetailsRequest,
    onSuccess: data => successAction(data),
  });

  const handleDetailsPageChange = (page: number, size: number) => {
    const bodyRequest = { ...aderenciaDetailsBodyRequest, page: page - 1, size };
    setAderenciaPrecosState('aderenciaDetailsBodyRequest', bodyRequest);
    mutate.mutateAsync(bodyRequest);
  };

  const handleDetailsLengthChange = (size: number) => {
    const bodyRequest = { ...aderenciaDetailsBodyRequest, size, page: 0 };
    setAderenciaPrecosState('aderenciaDetailsBodyRequest', bodyRequest);
    mutate.mutateAsync(bodyRequest);
  };

  const handleDetailsSortChange = (name: string, sortType: 'asc' | 'desc') => {
    const ordemOrdenacao = {
      asc: 'CRESCENTE',
      desc: 'DECRESCENTE',
    };
    const campoOrdenacao = {
      quantidadePrecosForaDoRange: 'TOTAL_PRECOS_FORA_DO_RANGE',
      quantidadeLojasDistintas: 'LOJAS_FORA_DO_RANGE',
      quantidadePreco: 'TOTAL_PRECOS',
    };
    const bodyRequest = { ...aderenciaDetailsBodyRequest, campoOrdenacao: campoOrdenacao[name], ordemOrdenacao: ordemOrdenacao[sortType], page: 0 };
    mutate.mutateAsync(bodyRequest);
  };

  const handleGetAderenciaDetails = (body: AderenciaBigNumbersBody) => {
    const bodyRequest = { ...aderenciaDetailsBodyRequest, ...body };
    setAderenciaPrecosState('aderenciaDetailsBodyRequest', bodyRequest);
    return mutate.mutateAsync(bodyRequest);
  };

  return {
    isLoadingDetails: mutate.isPending,
    handleGetAderenciaDetails,
    handleDetailsPageChange,
    handleDetailsLengthChange,
    handleDetailsSortChange,
  };
};
